import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UtilityService } from 'src/app/services/utility.service';
import { AssetService } from 'src/app/services/asset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { FilterService } from 'src/app/services/filter.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-add-asset-type',
  templateUrl: './add-asset-type.component.html',
  styleUrls: ['./add-asset-type.component.scss']
})
export class AddAssetTypeComponent implements OnInit {

  assetType: FormGroup
  loading: boolean;
  modelTitle: string;
  errorFromserver
  edited: boolean = false
  assetData

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private _utility: UtilityService,
    private _assetService: AssetService,
    private _utilityService: UtilityService,
    public activatedRouter: ActivatedRoute,
    public router: Router,
    private _filter: FilterService,
    public _userDocumentService: UserDocumentService
  ) { }


  ngOnInit() {
    this.loading = false;
    console.log("data===>", this.data);
    this.assetData = JSON.parse(JSON.stringify(this.data));
    this.createForm(this.data)
    if (this.data && this.data.edit == true) {
      this.edited = true
      this.modelTitle = 'Edit Asset Type'
    } else {
      this.modelTitle = 'Add Asset Type'
    }
  }

  // CREATE FORM
  createForm(data?) {
    console.log("data--->", data);
    this.assetType = new FormGroup({
      type: new FormControl((data && data.type) ? data.type : ''),
      inspectionDuration: new FormControl((this.data && this.data.inspectionDuration) ? this.data.inspectionDuration : ''),
      description: new FormControl((this.data && this.data.description) ? this.data.description : ''),
      isMultipleAssetlink: new FormControl((data && data.isMultipleAssetlink) ? data.isMultipleAssetlink : false)
    })
  }

  //UTILITY

  delete() {
    console.warn("DELETING ", this.data._id);
    let id = this.data._id;
    // console.log("this.assetData._id", this.assetData._id);
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "Asset type")
      .afterClosed().subscribe((data) => {
        if (data == '') return
        else if (data == 'yes') {
          this._assetService.deleteAssetType(id)
            .subscribe((data) => {
              console.log('Hello response data here ==>', data)
              this._utilityService.closeDialog(this.dialogRef, data)
            }, (error) => {
              console.log('delete asset some error occure!!!', error)
            })
        }
      })
  }


  // API CALL

  addType() {
    this.loading = true

    if (this.data && this.data.edit == true) {
      console.log("hello this edit asset-type data !!!", this.assetType.value)
      let data = this.assetType.value;
      data['_id'] = this.data._id
      this._assetService.editAssetType(data).subscribe((data) => {
        if (data.status == 200) {
          console.log('Hello response data here ==>', data)
          this.loading = false;
          this._utilityService.closeDialog(this.dialogRef, data)
        }
        else {
          this.errorFromserver = data.msg
          console.log("error", this.errorFromserver);
          this.loading = false;
        }
      }, (error) => {
        this.loading = false;
        console.log('edit asset-type some error occure!!!', error)
        // this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
        this.errorFromserver = error.msg
      }
      )
    }
    else {
      console.log("add asset type form values--->", this.assetType.value)
      this._assetService.addAssetType(this.assetType.value)
        .subscribe((data) => {
          console.log("data----->", data);

          if (data.status == 200) {
            console.log("this data response return data", data)
            this.loading = false;
            this._utilityService.closeDialog(this.dialogRef, data)
          }
          else {
            this.errorFromserver = data.msg
            console.log("error", this.errorFromserver);
            this.loading = false;
          }
        }, (error) => {
          this.loading = false;
          // this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
          this.errorFromserver = error.msg
          console.log("this error form server message", error)
        })
    }
  }
}
